import { mergeSpec } from "@visactor/vutils-extension";

import { makeDefaultPattern } from "./pattern";

import { memoize, isValid, array, isFunction, isNil, cloneDeep } from "@visactor/vutils";

import { getTooltipActualActiveType } from "./common";

import { addExtraInfoToTooltipContentPattern, addExtraInfoToTooltipTitlePattern } from "../../../series/base/tooltip-helper";

export const getTooltipSpecForShow = (activeType, globalSpec, series, dimensionInfo) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const finalSpec = Object.assign(Object.assign({}, globalSpec), {
        activeType: activeType
    }), {style: style = {}} = globalSpec;
    switch (activeType) {
      case "mark":
      case "group":
        if (series) {
            const seriesSpec = null !== (_b = null === (_a = series.tooltipHelper) || void 0 === _a ? void 0 : _a.spec) && void 0 !== _b ? _b : {};
            if (isValid(seriesSpec.visible) || isValid(seriesSpec.activeType) ? finalSpec.visible = getTooltipActualActiveType(seriesSpec).includes(activeType) : isValid(globalSpec.visible) || isValid(globalSpec.activeType) ? finalSpec.visible = getTooltipActualActiveType(globalSpec).includes(activeType) : finalSpec.visible = !0, 
            finalSpec.handler = null !== (_d = null !== (_c = seriesSpec.handler) && void 0 !== _c ? _c : globalSpec.handler) && void 0 !== _d ? _d : void 0, 
            null === (_e = finalSpec.handler) || void 0 === _e ? void 0 : _e.showTooltip) return finalSpec;
        }
        break;

      case "dimension":
        if (null == dimensionInfo ? void 0 : dimensionInfo.length) {
            if (getSeriesListFromDimensionInfo(dimensionInfo).every((series => {
                var _a;
                return !getTooltipActualActiveType(null === (_a = series.tooltipHelper) || void 0 === _a ? void 0 : _a.spec).includes("dimension");
            })) ? finalSpec.visible = !1 : isValid(globalSpec.visible) || isValid(globalSpec.activeType) ? finalSpec.visible = getTooltipActualActiveType(globalSpec).includes("dimension") : finalSpec.visible = !0, 
            finalSpec.handler = null !== (_f = globalSpec.handler) && void 0 !== _f ? _f : void 0, 
            null === (_g = finalSpec.handler) || void 0 === _g ? void 0 : _g.showTooltip) return finalSpec;
        }
    }
    const defaultPattern = getDefaultTooltipPattern(activeType, series, dimensionInfo), seriesPattern = getSeriesTooltipPattern(activeType, series, dimensionInfo), userPattern = mergeSpec({}, cloneDeep(globalSpec[activeType]), seriesPattern), defaultPatternTitle = defaultPattern.title, titleShape = getShapePattern(void 0, userPattern, style.shape, void 0, defaultPatternTitle);
    isValid(userPattern.title) ? userPattern.title = addExtraInfoToTooltipTitlePattern(userPattern.title, Object.assign(Object.assign({}, defaultPatternTitle), titleShape)) : userPattern.title = addExtraInfoToTooltipTitlePattern(defaultPatternTitle, titleShape, !0);
    const defaultPatternContent = array(defaultPattern.content);
    if (isValid(userPattern.content)) {
        const shapePatternMap = getShapePatternMapOfEachSeries(defaultPatternContent);
        userPattern.content = addExtraInfoToTooltipContentPattern(userPattern.content, (userLine => getShapePattern(userLine, userPattern, style.shape, shapePatternMap)));
    } else userPattern.content = addExtraInfoToTooltipContentPattern(defaultPatternContent, (line => getShapePattern(void 0, userPattern, style.shape, void 0, line)), !0);
    return finalSpec[activeType] = Object.assign(Object.assign(Object.assign({}, defaultPattern), userPattern), {
        activeType: activeType
    }), finalSpec;
};

const getDefaultTooltipPattern = (activeType, series, dimensionInfo) => {
    var _a;
    let defaultPattern = {};
    switch (activeType) {
      case "mark":
      case "group":
        series && (defaultPattern = null !== (_a = makeDefaultPattern(series, activeType)) && void 0 !== _a ? _a : {});
        break;

      case "dimension":
        if (null == dimensionInfo ? void 0 : dimensionInfo.length) {
            const patternList = [];
            dimensionInfo.forEach((({data: data}) => data.forEach((data => {
                const {series: series} = data, mockDimensionInfo = [ Object.assign(Object.assign({}, dimensionInfo[0]), {
                    data: [ data ]
                }) ], pattern = makeDefaultPattern(series, "dimension", mockDimensionInfo);
                pattern && patternList.push(pattern);
            }))));
            const defaultPatternContent = [];
            patternList.forEach((({content: content}) => {
                isFunction(content) ? defaultPatternContent.push(content) : defaultPatternContent.push(...array(content));
            })), defaultPattern = Object.assign(Object.assign({}, patternList[0]), {
                content: defaultPatternContent
            });
        }
    }
    return defaultPattern;
}, getSeriesTooltipPattern = (activeType, series, dimensionInfo) => {
    var _a, _b;
    let seriesPattern = {};
    switch (activeType) {
      case "mark":
      case "group":
        if (series) {
            const seriesSpec = null !== (_b = null === (_a = series.tooltipHelper) || void 0 === _a ? void 0 : _a.spec) && void 0 !== _b ? _b : {};
            seriesPattern = seriesSpec[activeType] ? cloneDeep(seriesSpec[activeType]) : {};
        }
        break;

      case "dimension":
        if (null == dimensionInfo ? void 0 : dimensionInfo.length) {
            const seriesPatternList = getSeriesListFromDimensionInfo(dimensionInfo).filter((series => {
                var _a;
                const spec = null === (_a = series.tooltipHelper) || void 0 === _a ? void 0 : _a.spec;
                return isValid(null == spec ? void 0 : spec.dimension) && getTooltipActualActiveType(spec).includes("dimension");
            })).map((series => series.tooltipHelper.spec.dimension));
            if (seriesPatternList.length) {
                let seriesPatternContent = [];
                seriesPatternList.every((({content: content}) => isNil(content))) ? seriesPatternContent = void 0 : seriesPatternList.forEach((({content: content}) => {
                    isNil(content) || (isFunction(content) ? null == seriesPatternContent || seriesPatternContent.push(content) : null == seriesPatternContent || seriesPatternContent.push(...array(content)));
                })), seriesPattern = Object.assign(Object.assign({}, seriesPatternList[0]), {
                    content: seriesPatternContent
                });
            }
        }
    }
    return seriesPattern;
}, getSeriesListFromDimensionInfo = memoize((dimensionInfo => dimensionInfo.reduce(((list, cur) => list.concat(cur.data.map((data => data.series)).filter(isValid))), []))), getShapePatternMapOfEachSeries = content => {
    const shapePatternMap = {};
    return content.forEach((line => {
        var _a;
        const key = null !== (_a = line.seriesId) && void 0 !== _a ? _a : 0;
        shapePatternMap[key] || (shapePatternMap[key] = line);
    })), shapePatternMap;
}, getShapePattern = (userLinePattern, userPattern, userStyle, shapePatternMap, defaultShapePattern) => {
    var _a, _b, _c;
    userStyle && (userStyle.shapeSize = null !== (_a = userStyle.shapeSize) && void 0 !== _a ? _a : userStyle.size);
    const maps = [ userLinePattern, userPattern, userStyle, null !== (_c = null == shapePatternMap ? void 0 : shapePatternMap[null !== (_b = null == userLinePattern ? void 0 : userLinePattern.seriesId) && void 0 !== _b ? _b : 0]) && void 0 !== _c ? _c : null == shapePatternMap ? void 0 : shapePatternMap[0], defaultShapePattern ].filter(isValid), shapeKeys = new Set(maps.reduce(((keys, cur) => keys.concat(Object.keys(cur))), []).filter((key => key.toLowerCase().includes("shape")))), shapePattern = {};
    return shapeKeys.forEach((key => {
        let value, i = 0;
        do {
            value = maps[i++][key];
        } while (i < maps.length && isNil(value));
        void 0 !== value && (shapePattern[key] = value);
    })), shapePattern;
};
//# sourceMappingURL=get-spec.js.map
